"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePhone = changePhone;
var _action_types = require("../../constants/action_types");
function changePhone(phone) {
  return {
    type: _action_types.PHONE_AUTH_CHANGE_PHONE_TYPE,
    phone
  };
}